<template>
  <div class="swiper-slide panel-item">
    <nuxt-link :to="url">
      <div class="panel-header">
        <template v-if="isLazy">
          <img :data-src="mainPhoto" :alt="facility.name" class="swiper-lazy" />
          <div class="swiper-lazy-preloader"></div>
        </template>
        <template v-else>
          <img :src="mainPhoto" :alt="facility.name" />
        </template>
      </div>
      <div class="panel-body">
        <kcs-area-label
          :prefecture="labels.prefecture"
          :city="labels.city"
          :facility-type="labels.facilityType"
        />
        <h3 class="panel-name">{{ facility.name }}</h3>
        <p class="panel-lead hide-sp">{{ facility.introduction }}</p>
        <p class="panel-point">
          <kcs-rating :rating="facility.rating || 0" />
        </p>
        <p class="btn-wrapper">
          <span class="btn fac">この施設を詳しく見る</span>
        </p>
      </div>
    </nuxt-link>
  </div>
</template>

<script>
import { createUrl } from '@/utils/create-url'
import { methods } from '@/utils/methods'
import KcsRating from '@/components/atoms/kcs-rating.vue'
import KcsAreaLabel from '@/components/atoms/kcs-area-label.vue'

export default {
  components: {
    KcsAreaLabel,
    KcsRating
  },
  props: {
    facility: {
      type: Object,
      required: true
    },
    isLazy: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    url() {
      return createUrl.createFacilityUrl(this.facility.code)
    },
    labels() {
      // エリア、都道府県、市区町村を取得
      return methods.getAreaLabel(this.facility)
    },
    mainPhoto() {
      return methods.getPhotoUrl({
        photo: this.facility.main_photo,
        id: this.facility.id,
        width: 720,
        height: 540
      })
    }
  }
}
</script>
